module.exports = __webpack_public_path__ + "static/okonomiforbundet-9e7646931c7003858b52d77e0495b4ef.png";